import { render, staticRenderFns } from "./OverflowTextControl.vue?vue&type=template&id=5807a3aa&"
import script from "./OverflowTextControl.vue?vue&type=script&lang=ts&"
export * from "./OverflowTextControl.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports